// aws-exports.js
const awsConfig = {
    Auth: {
        region: process.env.REACT_APP_REGION,
        userPoolId: process.env.REACT_APP_ADMIN_COGNITO_USERPOOL_ID,
        userPoolWebClientId: process.env.REACT_APP_SCHOOL_COGNITO_CLIENT_ID,
        identityPoolId: process.env.REACT_APP_ADMIN_COGNITO_IDENTITY_POOL_ID,
        authenticationFlowType: 'CUSTOM_AUTH'
    },
    Storage: {
        AWSS3: {
            bucket: process.env.REACT_APP_BUCKET_NAME,
            region: process.env.REACT_APP_REGION,
        }
    }
};
  
export default awsConfig;
  